import { v4 } from 'uuid';

export const newWorker = path => {
  // create worker to be used by Worker component.
  // this is a regular worker but a `callFunction` method will be added
  // to abstract away the message passing
  const worker = new Worker(path);

  // registered callbacks by key
  const callbacks = {};

  // listen for message and pass to callback
  worker.onmessage = e => {
    const { key, result } = e.data;

    // if there isn't a key, then it's safe to ignore this message
    if (!key) {
      return;
    }

    // enable logging
    if (key === 'log') {
      console.log(result);
    }

    const callback = callbacks[key];

    if (callback) {
      if (result.error) {
        console.error(result.error);
      } else {
        callback(result.data);
      }
    }
  }

  worker.callFunction = (fn, args, callback, opts = {}) => {
    // register callback
    let key = v4();
    callbacks[key] = callback;

    // setup hooks.
    // hooks are functions that can't be ran in the worker
    // and need to be ran by this component.
    // they are implemented here as callbacks,
    // and for each one a function is created for the worker to call it.
    // this is all abstracted away here,
    // so that a simple object of functions can be passed as "hooks"
    let hookKeys = {};
    if (opts.hooks) {
      for (let hookName in opts.hooks) {
        let hookKey = v4();
        callbacks[hookKey] = opts.hooks[hookName];
        hookKeys[hookName] = hookKey;
      }
    }

    // post message to worker
    let message = { fn, args, key, hookKeys };

    if (opts.transfer) {
      // "opts.transfer" should be an array of args to transfer instead of copy
      worker.postMessage(message, opts.transfer);
    } else {
      worker.postMessage(message);
    }
  }

  return worker;
}
